import { z } from "zod";

export const GetIntelligenceQuestionsSchema = z.object({
  questions: z.array(
    z.object({
      id: z.number(),
      text: z.string(),
      createdProjectChapter: z.object({ id: z.number(), name: z.string() }).nullable(),
      research: z
        .object({
          message: z.string(),
          newChapterDetails: z.object({
            projectChapterId: z.number(),
            name: z.string()
          })
        })
        .optional()
    })
  )
});

export type TIntelligenceQuestions = z.infer<typeof GetIntelligenceQuestionsSchema>;
export type TIntelligenceQuestion = z.infer<typeof GetIntelligenceQuestionsSchema>["questions"][number];
